var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "superado-limite-de-descargas-usuario",
    transform: "translate(-727.000000, -593.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(348.000000, 514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "corona",
    transform: "translate(379.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-29",
    fill: "#FA8C00",
    x: 1.52564103,
    y: 10.7692308,
    width: 11.2179487,
    height: 2.6025641
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FF8C00",
    points: "1.37656906 8.70512821 7.01594359 0.0610440458 12.7573624 8.70512821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#EDA500",
    points: "12.674398 10.103844 13.9868803 2.47032414 2.82248508 9.80217111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#FEC400",
    points: "1.33463643 10.057817 0.0754954515 2.43268193 10.5032807 10.057817"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.c8b26889c8fcdd5a511a40115817809c.svg";
export { ForwardRef as ReactComponent };